var _circle, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNavSearchParticipant = function SvgIconNavSearchParticipant(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 81.271,
    viewBox: "0 0 87.818 81.271",
    width: 87.818,
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.972,
    cy: 18.793,
    fill: "#fff",
    r: 16.293,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1285.685 130.666a16.287 16.287 0 0 1 -24.741-.375c-17.822 5.867-22.94 24.965-22.94 31.5 10.019 5.333 55.27 6.3 68.36-.646 0-9.016-4.596-24.802-20.679-30.479z",
    fill: "#11526a",
    stroke: "#11526a",
    transform: "translate(-1237.504 -93.469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1335.422 127.11a23.1 23.1 0 1 0 23.1 23.1 23.1 23.1 0 0 0 -23.1-23.1z",
    fill: "#fff",
    transform: "translate(-1270.708 -92.048)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNavSearchParticipant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nav-search-participant.1be6789d.svg";
export { ForwardRef as ReactComponent };